import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";

const API = process.env.REACT_APP_API;

/**
 * Hook para cancelar/descancelar items agrupados por FarmerOrder + Product.
 *
 * BREAKING CHANGE: Agora usa endpoints separados para cancelar/descancelar
 * ao invés de status genérico.
 *
 * - Para cancelar: action = 'cancel'
 * - Para descancelar: action = 'uncancel'
 */
const useCancelGroupedItems = () => {
  const queryClient = useQueryClient();
  const fetch = useFetch();

  return useMutation({
    mutationFn: ({
      farmerOrderId,
      productId,
      orderItemIds,
      action,
      reason,
    }: {
      farmerOrderId: number;
      productId: number;
      orderItemIds: number[];
      action: "cancel" | "uncancel";
      reason?: string;
    }) => {
      const endpoint =
        action === "cancel"
          ? `${API}/api/order-item/cancel-group`
          : `${API}/api/order-item/uncancel-group`;

      return fetch(endpoint, {
        method: "POST",
        body: {
          farmer_order_id: farmerOrderId,
          product_id: productId,
          order_item_ids: orderItemIds,
          reason: reason || "",
        },
      });
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["farmerOrders"] });
      queryClient.invalidateQueries({ queryKey: ["orders"] });
    },
  });
};

// Alias para compatibilidade (deprecated)
export const useUpdateGroupedOrderItemsStatus = useCancelGroupedItems;

export default useCancelGroupedItems;
